import { DashboardView } from '@views';
import { Box, Container, Skeleton, Typography } from '@mui/material';
import React from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const DashboardHeader = (props: { loading: boolean; view: DashboardView }) => {
  const { loading, view } = props;
  return (
    <Container
      sx={{
        padding: '2rem 0 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
      }}
    >
      {loading ? (
        <Typography variant="h3">
          <Skeleton width="80%" />
        </Typography>
      ) : (
        <>
          <Typography variant="h1" sx={{ fontWeight: 700, fontSize: '25px', color: '#C53247' }}>
            {view.groupName}
          </Typography>
          <Box sx={{ textAlign: 'right', color: '#C53247' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', minWidth: '120px' }}>
              <CalendarMonthIcon fontSize="medium" sx={{ marginRight: 0.5 }} />
              <h3 style={{ fontWeight: '500', fontFamily: 'Roboto, sans-serif', margin: '0', fontSize: '18px' }}>
                Week {view.currentWeekNumberIndexZero < 0 ? 0 : view.currentWeekNumberIndexZero}
              </h3>
            </Box>
            {view.currentWeekNumberIndexZero === 0 && (
              <p style={{ marginTop: '0', fontSize: '12px' }}>Onboarding Week</p>
            )}
          </Box>
        </>
      )}
    </Container>
  );
};
